import { render, staticRenderFns } from "./propertyBlock.vue?vue&type=template&id=de18b74a&"
import script from "./propertyBlock.vue?vue&type=script&lang=js&"
export * from "./propertyBlock.vue?vue&type=script&lang=js&"
import style0 from "./propertyBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports